module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C69"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C75"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface_#page_ix"
    }
  }, [_vm._v("Preface: Even Detroit")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_1__What#page_1"
    }
  }, [_vm._v("1. What We’ve Lost—and Why")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_2__Fleei#page_15"
    }
  }, [_vm._v("2. Fleeing Robin Hood")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_3__A_1_P#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A 1-Percent Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_4__The_C#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Conquest of Capital")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_5__A_Bet#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Better Climate")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_6__Thing#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Things Fall Apart")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_7__Three#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Three Simple Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_8__No_Li#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. No Little Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_9__Contr#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Control Freaks")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_10__Recl#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Reclaiming the Commons")])]), _vm._v(" "), _c('p', {
    staticClass: "C75"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_11__Boom#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Boom Commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Acknowle#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Notes#page_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C76"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Index#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0